// removed by extract-text-webpack-plugin
module.exports = {"FileInputWrapper":"_17XeLs5YYAZaPBPmTK7Xg5","FileInputButton":"_20dTHce_btoiMAZXVyogzb","FileInput":"_4EsKqB8lUaulyGCH1fq84"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Conversation/FileInput/style.css
// module id = 2008
// module chunks = 0